import { listRoutesChannel } from "modules/Channel/configs/routeConfig";

import { listRoutesUAA } from "../modules/UAA/configs/routeConfig";

export const appRoute = [listRoutesChannel, listRoutesUAA];
